import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/python': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M439.8 200.5c10.7 42.9 11.2 75.1 0 108.6-10.8 32.5-22.3 54.2-53.4 54.2h-160.2v13.6h106.7v40.7c0 30.8-26.5 46.5-53.4 54.3-40.5 11.7-73 9.9-106.8 0-28.2-8.3-53.4-25.3-53.4-54.3v-101.8c0-29.3 24.2-54.3 53.4-54.3h106.8c35.6 0 66.8-31 66.8-67.8v-47.4h40.1c31.1 0 45.7 23.3 53.4 54.2zM286.2 404c-11 0-20 9-20.1 20.3 0 11.2 9.1 20.4 20.1 20.4 11.1 0 20.1-9.1 20.1-20.4 0-11.2-9-20.3-20.1-20.3zM167.8 248.1c-36.3 0-66.8 31.1-66.8 66.4v48.8h-36.7c-31.1 0-49.2-22.6-56.8-54.2-10.2-42.5-9.8-67.9 0-108.6 8.5-35.5 35.7-54.2 66.8-54.2h147v-13.6h-106.9v-40.7c0-30.9 8.2-47.6 53.4-55.6 32.1-5.7 71-6 106.8-0.1 29 4.9 53.4 26.6 53.4 55.6v101.9c0 29.8-23.7 54.3-53.4 54.3h-106.8zM161.1 105.5c11.1 0 20.1-9.1 20.1-20.3s-9.1-20.4-20.1-20.4c-11.1 0-20 9.1-20.1 20.4 0 11.2 9 20.3 20.1 20.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/brands/python.js
// module id = 820
// module chunks = 0